"use strict";

var _asyncToGenerator = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    throw: verb(1),
    return: verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    default: mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var WalletSelector_1 = __importDefault(require("./WalletSelector"));
var Create_1 = __importDefault(require("./Create"));
var Confirm_1 = __importDefault(require("./Create/Confirm"));
var Backup_1 = __importDefault(require("./Create/Backup"));
var AddFunds_1 = __importDefault(require("./Create/AddFunds"));
var Input_1 = __importDefault(require("./Input"));
var Select_1 = __importDefault(require("./Select"));
var qrImage = __importStar(require("qr-image"));
var wallets_1 = require("../../wallets");
var wallet_1 = require("../../selector/wallet");
var wallet_2 = require("../../actions/wallet");
var _require = require("react-toastify"),
  toast = _require.toast;
var Svg_1 = __importDefault(require("../Svg"));
var NotSupport_1 = __importDefault(require("./NotSupport"));
var i18n_1 = __importDefault(require("../../i18n"));
var HardwareWalletConnector_1 = __importDefault(require("./HardwareWalletConnector"));
var Wallet = function (_super) {
  __extends(Wallet, _super);
  function Wallet(props) {
    var _this = _super.call(this, props) || this;
    var _a = _this.props,
      defaultWalletType = _a.defaultWalletType,
      translations = _a.translations,
      dispatch = _a.dispatch,
      customLocalWallet = _a.customLocalWallet,
      unit = _a.unit,
      decimals = _a.decimals;
    dispatch(wallet_2.setTranslations(translations || i18n_1.default));
    if (customLocalWallet) {
      dispatch(wallet_2.initCustomLocalWallet(customLocalWallet));
    }
    if (unit && typeof decimals === "number") {
      dispatch(wallet_2.setUnit(unit, decimals));
    }
    var selectedWalletType;
    var lastSelectedWalletType = window.localStorage.getItem("RainWallet:lastSelectedWalletType");
    if (defaultWalletType) {
      selectedWalletType = defaultWalletType;
    } else if (lastSelectedWalletType) {
      selectedWalletType = lastSelectedWalletType;
    } else {
      selectedWalletType = wallets_1.defaultWalletTypes[0];
    }
    dispatch(wallet_2.selectWalletType(selectedWalletType));
    _this.state = {
      password: "",
      processing: false,
      checkbox: false,
      loader: false
    };
    return _this;
  }
  Wallet.prototype.componentDidMount = function () {
    var _a = this.props,
      nodeUrl = _a.nodeUrl,
      email = _a.email,
      host = _a.host;
    if (typeof window !== "undefined") {
      var TrezorConnect = require("trezor-connect").default;
      TrezorConnect.manifest({
        email: email || "developer@xyz.com",
        appUrl: host || "http://your.application.com"
      });
    }
    if (nodeUrl) {
      wallets_1.setGlobalNodeUrl(nodeUrl);
    }
    this.loadWallets();
  };
  Wallet.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
      selectedAccount = _a.selectedAccount,
      isShowWalletModal = _a.isShowWalletModal,
      dispatch = _a.dispatch,
      translations = _a.translations;
    if (!isShowWalletModal &&
    // isShowWalletModal !== prevProps.isShowWalletModal &&
    selectedAccount) {
      var wallet = selectedAccount.get("wallet");
      dispatch(wallet_2.selectWalletType(wallet.type()));
    }
    if (translations && translations !== prevProps.translations) {
      dispatch(wallet_2.setTranslations(translations));
    }
  };
  Wallet.prototype.componentWillUnmount = function () {
    wallet_2.destoryTimer();
  };
  Wallet.prototype.loadWallets = function () {
    var _a = this.props,
      dispatch = _a.dispatch,
      walletTypes = _a.walletTypes,
      loadWalletActions = _a.loadWalletActions;
    var types = walletTypes ? walletTypes : wallets_1.defaultWalletTypes;
    types.map(function (type) {
      var loadWalletAction = loadWalletActions ? loadWalletActions[type] : null;
      dispatch(wallet_2.loadWallet(type, loadWalletAction));
    });
  };
  Wallet.prototype.render = function () {
    var _a = this.props,
      isShowWalletModal = _a.isShowWalletModal,
      dispatch = _a.dispatch,
      LocalWallet = _a.LocalWallet,
      walletTranslations = _a.walletTranslations,
      selectedWalletType = _a.selectedWalletType;
    return React.createElement("div", {
      className: "RainConnect-wallet"
    }, React.createElement("div", {
      className: "RainConnect-container",
      hidden: !isShowWalletModal
    }, React.createElement("div", {
      className: "RainConnect-backdrop",
      onClick: function onClick() {
        return dispatch(wallet_2.hideWalletModal());
      }
    }), React.createElement("div", {
      className: "RainConnect-dialog pl-5 pr-5"
    }, React.createElement("div", {
      className: "RainConnect-title"
    }, walletTranslations.dialogTitle), walletTranslations.dialogSubtitle && React.createElement("div", {
      className: "RainConnect-desc"
    }, walletTranslations.dialogSubtitle), React.createElement("div", {
      className: "RainConnect-fieldGroup"
    }, React.createElement("div", {
      className: "RainConnect-label selectwallet"
    },
    // walletTranslations.selectWallet,
    selectedWalletType == _a.defaultWalletType && walletTranslations.selectWallet), React.createElement(Select_1.default, {
      options: this.getWalletsOptions(),
      selected: selectedWalletType
    })), this.renderStepContent(), this.renderUnlockForm(), this.renderDeleteForm(), this.renderDesc(), !LocalWallet.TYPE.includes(selectedWalletType) && React.createElement("div", {
      className: "row col-12 justify-content-center mt-5"
    }, React.createElement("button", {
      className: "RainConnect-button RainConnect-closeButton",
      onClick: function onClick() {
        return dispatch(wallet_2.hideWalletModal());
      }
    }, walletTranslations.close), this.renderFeatureButton()))));
  };
  Wallet.prototype.renderDesc = function () {
    var _a = this.props,
      selectedWalletType = _a.selectedWalletType,
      walletTranslations = _a.walletTranslations,
      selectedAccount = _a.selectedAccount;
    var title = "",
      desc = "";
    if (selectedWalletType) {
      var statusKey = "notConnect";
      var wallet = selectedAccount ? selectedAccount.get("wallet") : null;
      if (wallet && wallet.type() === selectedWalletType) {
        statusKey = "connected";
      }
      var key = selectedWalletType.toLowerCase();
      var walletDesc = walletTranslations.walletDesc[statusKey][key];
      if (walletDesc) {
        title = walletDesc.title;
        desc = walletDesc.desc;
      }
    }
    return React.createElement("div", {
      className: "RainConnect-walletDesc"
    }, React.createElement("div", {
      className: "RainConnect-walletDescTitle"
    }, title), React.createElement("div", {
      className: "RainConnect-walletDescDesc",
      dangerouslySetInnerHTML: {
        __html: desc
      }
    }));
  };
  Wallet.prototype.renderFeatureButton = function () {
    var _this = this;
    var _a = this.props,
      selectedWalletType = _a.selectedWalletType,
      walletTranslations = _a.walletTranslations,
      accounts = _a.accounts,
      connecting = _a.connecting;
    var account = accounts.get(selectedWalletType);
    var address = account ? account.get("address") : null;
    var isLocked = account ? account.get("isLocked") : true;
    if (address && !isLocked) {
      return null;
    }
    if (selectedWalletType === wallets_1.Dcent.TYPE || selectedWalletType === wallets_1.CoinbaseWallet.TYPE || selectedWalletType === wallets_1.Fortmatic.TYPE || selectedWalletType === wallets_1.ExtensionWallet.TYPE || selectedWalletType === wallets_1.Ledger.TYPE || selectedWalletType === wallets_1.Trezor.TYPE || selectedWalletType === wallets_1.Torus.TYPE) {
      return React.createElement("button", {
        className: "RainConnect-button RainConnect-featureButton ml-3",
        onClick: function onClick() {
          _this.setState({
            loader: true
          });
          if (window.ethereum) {
            return _this.connectBridge();
          } else {
            toast.warn("Please Install Metamask");
            _this.setState({
              loader: false
            });
          }
        },
        disabled: this.state.loader
      }, this.state.loader ? React.createElement("i", {
        className: "RainConnect-fa fa fa-spinner fa-spin"
      }) : null, " ", walletTranslations.connect);
    }
    return null;
  };
  Wallet.prototype.connectBridge = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _a, selectedWalletType, dispatch, dcent, appName, appLogoUrl, fortmaticApiKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _a = this.props, selectedWalletType = _a.selectedWalletType, dispatch = _a.dispatch, dcent = _a.dcent, appName = _a.appName, appLogoUrl = _a.appLogoUrl, fortmaticApiKey = _a.fortmaticApiKey;
          if (!(selectedWalletType === wallets_1.CoinbaseWallet.TYPE)) {
            _context.next = 5;
            break;
          }
          dispatch(wallet_2.loadCoinbaseWallet(appName, appLogoUrl));
          _context.next = 26;
          break;
        case 5:
          if (!(selectedWalletType === wallets_1.Dcent.TYPE && dcent)) {
            _context.next = 9;
            break;
          }
          dispatch(wallet_2.loadDcentWallet(dcent));
          _context.next = 26;
          break;
        case 9:
          if (!(selectedWalletType === wallets_1.Fortmatic.TYPE && fortmaticApiKey)) {
            _context.next = 13;
            break;
          }
          dispatch(wallet_2.loadFortmaticWallet(fortmaticApiKey));
          _context.next = 26;
          break;
        case 13:
          if (!(selectedWalletType === wallets_1.ExtensionWallet.TYPE && window.ethereum)) {
            _context.next = 25;
            break;
          }
          _context.prev = 14;
          _context.next = 17;
          return dispatch(wallet_2.loadExtensionWallet());
        case 17:
          this.setState({
            loader: false
          });
          _context.next = 23;
          break;
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](14);
          this.setState({
            loader: false
          });
        case 23:
          _context.next = 26;
          break;
        case 25:
          if (selectedWalletType === wallets_1.Ledger.TYPE) {
            dispatch(wallet_2.loadLedger());
          } else if (selectedWalletType === wallets_1.Trezor.TYPE) {
            dispatch(wallet_2.loadTrezor());
          } else if (selectedWalletType === wallets_1.Torus.TYPE) {
            dispatch(wallet_2.loadTorus());
          }
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee, this, [[14, 20]]);
  }));
  Wallet.prototype.renderStepContent = function () {
    var _a = this.props,
      extensionWalletSupported = _a.extensionWalletSupported,
      accounts = _a.accounts,
      step = _a.step,
      walletTranslations = _a.walletTranslations,
      selectedWalletType = _a.selectedWalletType,
      copyCallback = _a.copyCallback;
    switch (step) {
      case wallet_2.WALLET_STEPS.SELECT:
      case wallet_2.WALLET_STEPS.DELETE:
        if (selectedWalletType === wallets_1.WalletConnectWallet.TYPE) {
          var account = accounts.get(wallets_1.WalletConnectWallet.TYPE);
          if (account && account.get("isLocked")) return this.renderQrImage();
        } else if (selectedWalletType === wallets_1.Ledger.TYPE) {
          return React.createElement(HardwareWalletConnector_1.default, {
            copyCallback: copyCallback,
            walletClass: wallets_1.Ledger
          });
        } else if (selectedWalletType === wallets_1.Trezor.TYPE) {
          return React.createElement(HardwareWalletConnector_1.default, {
            copyCallback: copyCallback,
            walletClass: wallets_1.Trezor
          });
        } else if (selectedWalletType === wallets_1.ExtensionWallet.TYPE && !extensionWalletSupported) {
          return React.createElement(NotSupport_1.default, {
            iconName: "metamask",
            title: walletTranslations.installMetamask,
            desc: walletTranslations.installMetamaskDesc
          });
        } else if (selectedWalletType === wallets_1.Dcent.TYPE || selectedWalletType === wallets_1.CoinbaseWallet.TYPE || selectedWalletType === wallets_1.Fortmatic.TYPE || selectedWalletType === wallets_1.Torus.TYPE) {
          var selectedAccount = accounts.get(selectedWalletType);
          var selectedAddress = selectedAccount ? selectedAccount.get("address") : null;
          if (!selectedAddress) {
            return null;
          }
        }
        return React.createElement(WalletSelector_1.default, {
          walletType: selectedWalletType,
          copyCallback: copyCallback
        });
      case wallet_2.WALLET_STEPS.CREATE:
        return React.createElement(Create_1.default, null);
      case wallet_2.WALLET_STEPS.CREATE_CONFIRM:
        return React.createElement(Confirm_1.default, null);
      case wallet_2.WALLET_STEPS.BACKUP:
        return React.createElement(Backup_1.default, null);
      case wallet_2.WALLET_STEPS.ADD_FUNDS:
        return React.createElement(AddFunds_1.default, null);
      case wallet_2.WALLET_STEPS.IMPORT:
        return React.createElement(Create_1.default, {
          isRecovery: true
        });
      default:
        return null;
    }
  };
  Wallet.prototype.renderQrImage = function () {
    var accounts = this.props.accounts;
    var wallet = accounts.get(wallets_1.WalletConnectWallet.TYPE).get("wallet");
    var connector = wallet.connector;
    return React.createElement("div", {
      className: "RainConnect-qr-image"
    }, React.createElement("div", {
      className: "RainConnect-qr-image-bg",
      dangerouslySetInnerHTML: {
        __html: qrImage.imageSync(connector.uri, {
          type: "svg",
          ec_level: "L"
        }).toString()
      }
    }));
  };
  Wallet.prototype.renderUnlockForm = function () {
    var _this = this;
    var _a = this.state,
      password = _a.password,
      processing = _a.processing;
    var _b = this.props,
      selectedAccount = _b.selectedAccount,
      step = _b.step,
      walletTranslations = _b.walletTranslations,
      selectedWalletType = _b.selectedWalletType,
      LocalWallet = _b.LocalWallet;
    if (selectedWalletType !== LocalWallet.TYPE || step !== wallet_2.WALLET_STEPS.SELECT && step !== wallet_2.WALLET_STEPS.DELETE || !selectedAccount || !selectedAccount.get("isLocked")) {
      return null;
    }
    return React.createElement(React.Fragment, null, React.createElement(Input_1.default, {
      label: walletTranslations.password,
      text: password,
      handleChange: function handleChange(password) {
        return _this.setState({
          password: password
        });
      }
    }), React.createElement("button", {
      className: "RainConnect-button RainConnect-submitButton RainConnect-featureButton",
      disabled: processing,
      onClick: function onClick() {
        return _this.handleUnlock(selectedAccount);
      }
    }, processing ? React.createElement("i", {
      className: "RainConnect-fa fa fa-spinner fa-spin"
    }) : null, " ", walletTranslations.unlock));
  };
  Wallet.prototype.renderDeleteForm = function () {
    var _this = this;
    var _a = this.state,
      checkbox = _a.checkbox,
      processing = _a.processing;
    var _b = this.props,
      selectedAccount = _b.selectedAccount,
      step = _b.step,
      walletTranslations = _b.walletTranslations,
      selectedWalletType = _b.selectedWalletType,
      LocalWallet = _b.LocalWallet;
    if (!selectedAccount || selectedAccount.get("isLocked") || selectedAccount.get("wallet").type() !== LocalWallet.TYPE || step !== wallet_2.WALLET_STEPS.DELETE || selectedWalletType !== LocalWallet.TYPE) {
      return null;
    }
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "RainConnect-hint"
    }, React.createElement("div", {
      className: "RainConnect-hintTitle"
    }, React.createElement("i", {
      className: "RainConnect-fa fa fa-bullhorn"
    }), walletTranslations.headsUp), React.createElement("span", null, walletTranslations.deleteTip), React.createElement("div", {
      className: "RainConnect-checkboxDiv " + (checkbox ? "checked" : ""),
      onClick: function onClick() {
        return _this.setState({
          checkbox: !checkbox
        });
      }
    }, React.createElement("div", {
      className: "RainConnect-checkbox"
    }, React.createElement("i", {
      className: "fa fa-check"
    })), walletTranslations.deleteConfirm)), React.createElement("button", {
      className: "RainConnect-button RainConnect-submitButton RainConnect-featureButton",
      disabled: processing || !checkbox,
      onClick: function onClick() {
        return _this.handleDelete(selectedAccount);
      }
    }, processing ? React.createElement("i", {
      className: "RainConnect-fa fa fa-spinner fa-spin"
    }) : null, " ", walletTranslations.delete));
  };
  Wallet.prototype.handleDelete = function (selectedAccount) {
    return __awaiter(this, void 0, void 0, function () {
      var e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);
            this.setState({
              processing: true
            });
            return [4, this.props.dispatch(wallet_2.deleteBrowserWalletAccount(selectedAccount))];
          case 1:
            _a.sent();
            return [3, 4];
          case 2:
            e_1 = _a.sent();
            alert(e_1);
            return [3, 4];
          case 3:
            this.setState({
              processing: false
            });
            return [7];
          case 4:
            return [2];
        }
      });
    });
  };
  Wallet.prototype.handleUnlock = function (selectedAccount) {
    return __awaiter(this, void 0, void 0, function () {
      var password, e_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);
            password = this.state.password;
            this.setState({
              processing: true
            });
            return [4, this.props.dispatch(wallet_2.unlockBrowserWalletAccount(selectedAccount, password))];
          case 1:
            _a.sent();
            return [3, 4];
          case 2:
            e_2 = _a.sent();
            alert(e_2);
            return [3, 4];
          case 3:
            this.setState({
              processing: false
            });
            return [7];
          case 4:
            return [2];
        }
      });
    });
  };
  Wallet.prototype.getWalletsOptions = function () {
    var _this = this;
    var IsLoadAllWallet = false;
    var _a = this.props,
      menuOptions = _a.menuOptions,
      dcent = _a.dcent,
      fortmaticApiKey = _a.fortmaticApiKey,
      accounts = _a.accounts,
      walletTranslations = _a.walletTranslations,
      mobileHide = _a.mobileHide;
    if (!menuOptions) {
      var wallet = accounts.getIn([wallets_1.ExtensionWallet.TYPE, "wallet"]);
      var extensionWalletLabel = wallet ? wallet.name() : wallets_1.ExtensionWallet.LABEL;
      menuOptions = [{
        value: wallets_1.ExtensionWallet.TYPE,
        component: React.createElement("div", {
          className: "RainConnect-optionItem RainConnect-noGroup"
        }, React.createElement(Svg_1.default, {
          name: "metamask"
        }), extensionWalletLabel),
        onSelect: function onSelect(option) {
          return _this.onSelect(option);
        }
      }];
      if (fortmaticApiKey) {
        menuOptions = menuOptions.concat([{
          value: wallets_1.Fortmatic.TYPE,
          component: React.createElement("div", {
            className: "RainConnect-optionItem RainConnect-noGroup"
          }, React.createElement(Svg_1.default, {
            name: "fortmatic"
          }), walletTranslations.usePhoneOrEmail, React.createElement("span", {
            className: "RainConnect-text-secondary"
          }, " ", "(", walletTranslations.poweredBy, " ", wallets_1.Fortmatic.LABEL, ")")),
          onSelect: function onSelect(option) {
            return _this.onSelect(option);
          }
        }]);
      }
      if (!mobileHide && IsLoadAllWallet) {
        menuOptions = menuOptions.concat([{
          value: "hardwareWallets",
          component: React.createElement("div", {
            className: "RainConnect-optionItem RainConnect-optionType"
          }, walletTranslations.hardwareWallets)
        }, {
          value: wallets_1.Ledger.TYPE,
          component: React.createElement("div", {
            className: "RainConnect-optionItem"
          }, React.createElement(Svg_1.default, {
            name: "ledger"
          }), wallets_1.Ledger.LABEL),
          onSelect: function onSelect(option) {
            return _this.onSelect(option);
          }
        }, {
          value: wallets_1.Trezor.TYPE,
          component: React.createElement("div", {
            className: "RainConnect-optionItem"
          }, React.createElement(Svg_1.default, {
            name: "trezor"
          }), wallets_1.Trezor.LABEL),
          onSelect: function onSelect(option) {
            return _this.onSelect(option);
          }
        }]);
        if (dcent) {
          menuOptions.push({
            value: wallets_1.Dcent.TYPE,
            component: React.createElement("div", {
              className: "RainConnect-optionItem"
            }, React.createElement(Svg_1.default, {
              name: "dcent"
            }), wallets_1.Dcent.LABEL),
            onSelect: function onSelect(option) {
              return _this.onSelect(option);
            }
          });
        }
      }
      if (!mobileHide && IsLoadAllWallet) {
        menuOptions = menuOptions.concat([{
          value: "mobileWallets",
          component: React.createElement("div", {
            className: "RainConnect-optionItem RainConnect-optionType"
          }, walletTranslations.mobileWallets)
        }, {
          value: wallets_1.WalletConnectWallet.TYPE,
          component: React.createElement("div", {
            className: "RainConnect-optionItem"
          }, React.createElement(Svg_1.default, {
            name: "WalletConnect"
          }), wallets_1.WalletConnectWallet.LABEL),
          onSelect: function onSelect(option) {
            return _this.onSelect(option);
          }
        }, {
          value: wallets_1.CoinbaseWallet.TYPE,
          component: React.createElement("div", {
            className: "RainConnect-optionItem"
          }, React.createElement(Svg_1.default, {
            name: "coinbase"
          }), wallets_1.CoinbaseWallet.LABEL),
          onSelect: function onSelect(option) {
            return _this.onSelect(option);
          }
        }]);
      }
      if (IsLoadAllWallet) {
        menuOptions = menuOptions.concat([{
          value: "oauth",
          component: React.createElement("div", {
            className: "RainConnect-optionItem RainConnect-optionType"
          }, walletTranslations.oauth)
        }, {
          value: wallets_1.Torus.TYPE,
          component: React.createElement("div", {
            className: "RainConnect-optionItem"
          }, React.createElement(Svg_1.default, {
            name: "torus"
          }), wallets_1.Torus.LABEL),
          onSelect: function onSelect(option) {
            return _this.onSelect(option);
          }
        }]);
      }
    }
    if (IsLoadAllWallet) {
      return menuOptions.concat(this.localWalletOptions());
    } else {
      return menuOptions;
    }
  };
  Wallet.prototype.onSelect = function (option) {
    this.props.dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.SELECT));
    this.props.dispatch(wallet_2.selectWalletType(option.value));
  };
  Wallet.prototype.localWalletOptions = function () {
    var _a = this.props,
      dispatch = _a.dispatch,
      walletTranslations = _a.walletTranslations,
      LocalWallet = _a.LocalWallet,
      hideLocalWallet = _a.hideLocalWallet,
      mobileHide = _a.mobileHide;
    if (hideLocalWallet || mobileHide) {
      return [];
    }
    var rainWalletsCount = LocalWallet.list().length;
    var isEmptyRainWallet = rainWalletsCount === 0;
    return [{
      value: "localWallets",
      component: React.createElement("div", {
        className: "RainConnect-optionItem RainConnect-optionType"
      }, walletTranslations.localWallets)
    }, {
      value: LocalWallet.TYPE,
      component: React.createElement("div", {
        className: "RainConnect-optionItem" + (isEmptyRainWallet ? " disabled" : "")
      }, React.createElement(Svg_1.default, {
        name: "logo"
      }), LocalWallet.LABEL, " (", rainWalletsCount, ")"),
      onSelect: function onSelect(option) {
        dispatch(wallet_2.setWalletStep(isEmptyRainWallet ? wallet_2.WALLET_STEPS.CREATE : wallet_2.WALLET_STEPS.SELECT));
        dispatch(wallet_2.selectWalletType(option.value));
      }
    }, {
      value: wallet_2.WALLET_STEPS.CREATE,
      component: React.createElement("div", {
        className: "RainConnect-optionItem RainConnect-walletFeature"
      }, React.createElement(Svg_1.default, {
        name: "create"
      }), walletTranslations.createWallet),
      onSelect: function onSelect() {
        dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.CREATE));
        dispatch(wallet_2.selectWalletType(LocalWallet.TYPE));
      }
    }, {
      value: wallet_2.WALLET_STEPS.IMPORT,
      component: React.createElement("div", {
        className: "RainConnect-optionItem RainConnect-walletFeature"
      }, React.createElement(Svg_1.default, {
        name: "import"
      }), walletTranslations.importWallet),
      onSelect: function onSelect() {
        dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.IMPORT));
        dispatch(wallet_2.selectWalletType(LocalWallet.TYPE));
      }
    }, {
      value: wallet_2.WALLET_STEPS.DELETE,
      component: React.createElement("div", {
        className: "RainConnect-optionItem RainConnect-walletFeature"
      }, React.createElement(Svg_1.default, {
        name: "delete"
      }), walletTranslations.deleteWallet),
      onSelect: function onSelect() {
        dispatch(wallet_2.setWalletStep(wallet_2.WALLET_STEPS.DELETE));
        dispatch(wallet_2.selectWalletType(LocalWallet.TYPE));
      }
    }];
  };
  return Wallet;
}(React.PureComponent);
exports.default = react_redux_1.connect(function (state) {
  var walletState = state.WalletReducer;
  return {
    walletTranslations: walletState.get("walletTranslations"),
    selectedAccount: wallet_1.getSelectedAccount(state),
    accounts: walletState.get("accounts"),
    extensionWalletSupported: walletState.get("extensionWalletSupported"),
    isShowWalletModal: walletState.get("isShowWalletModal"),
    step: walletState.get("step"),
    selectedWalletType: walletState.get("selectedWalletType"),
    LocalWallet: walletState.get("LocalWallet") || wallets_1.RainWallet,
    connecting: walletState.get("connecting")
  };
})(Wallet);